import styled from 'styled-components';

import { Headline } from 'components/atoms';
import { maxWidth, minWidth } from 'styles/media-queries';
import { gray20, solidWhite200 } from '@spotify-internal/encore-web';
import { fontWeights } from 'styles/variables';
import { white } from 'styles/colors';
import { spacer4 } from 'styles/spacers';

export const Root = styled.div`
  background-color: ${props => props.backgroundColor};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-bottom: 5.3rem;
  padding-top: 6.4rem;

  ${minWidth.lg`
    display: block;
    height: auto;
    padding-bottom: 8.5rem;
    padding-top: 8.85rem;
  `}
`;

export const Title = styled(Headline).attrs({ tag: 'h2', styling: 'h2' })`
  color: ${white};
  font-weight: ${fontWeights.bold};
  margin-bottom: 1rem;
  text-align: center;

  ${maxWidth.sm`
     font-size: 4rem;
     margin-bottom: 2rem;
  `}
`;

export const Subtitle = styled.p`
  color: ${white};
  font-weight: ${fontWeights.normal};
  margin-bottom: ${spacer4};
  text-align: center;
  padding-left: 3rem;
  padding-right: 3rem;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow-y: scroll;
  scrollbar-color: ${solidWhite200} ${gray20};
  scrollbar-width: thin;
  width: 100%;
  -webkit-overflow-scrolling: touch;

  ${minWidth.md`
    flex-direction: row;
    flex-wrap: wrap;
    flex: -1;
    height: 50vh;
    max-height: 48.8rem;
  `}

  &::-webkit-scrollbar {
    width: 0.4rem;
  }

  &::-webkit-scrollbar-track {
    background: ${gray20};
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${solidWhite200};
    border-radius: 0.4rem;
  }
`;

export const CountryItem = styled.div`
  margin-bottom: 1.6rem;
  position: relative;
  align-items: center;
  display: flex;
  flex-direction: row;
  text-decoration: none;

  ${minWidth.md`
    flex: 60%;

    &:nth-child(even) {
      flex: 40%;
    }
  `}
`;

export const CountryName = styled.span`
  color: ${props => props.color};
  font-size: 1.6rem;
  line-height: 2.4rem;

  ${minWidth.lg`
    font-size: 2rem;
    line-height: 3.2rem;
  `}
`;

export const CountryFlag = styled.div`
  display: flex;
  height: 1.8rem;
  margin-right: 1.6rem;
  width: 2.4rem;

  & svg {
    flex: 1;
  }
`;
